<template>
  <span>
    <img :src="`${base_cdn}/lecard-corporativo/icones/${name || 'default'}-light.svg`" alt="Ícone" :style="`width: ${size || '28'}px`" v-if="light">
    <img :src="`${base_cdn}/lecard-corporativo/icones/${name || 'default'}.svg`" alt="Ícone" :style="`width: ${size || '28'}px`" v-else>
  </span>
</template>
<script>
  export default {
    name: "icon-categoria",
    props: ['name','light', 'size']
  }
</script>
<style scoped>

</style>
